<template>
    <span class="app-spinner"></span>
</template>

<script>
export default {
  name: 'appSpinner',
}
</script>
